import { ADD_HOLIDAY_DATA, HOLIDAY_LIST, LOGIN, REQ_USER } from "./ActionType";

const initialValue = {
  signin: null,
  reqUser: null,
  holidaylist: [],
  updateholidaydata: [],
};

export const authReducer = (store = initialValue, { type, payload }) => {
  if (type === LOGIN) {
    return { ...store, signin: payload };
  } else if (type === REQ_USER) {
    return { ...store, reqUser: payload };
  } else if (type === HOLIDAY_LIST) {
    return { ...store, holidaylist: payload.holidayList || [] };
  } else if (type === ADD_HOLIDAY_DATA) {
    return {
      ...store,
      updateholidaydata: payload
    };
  }

  return store;
};
